export enum CollectionType {
	Workflow = 2,
	ControlledDocument = 3
}